export default __webpack_public_path__ + "static/media/top-tree.bec1b408.png";